import { zeroPadding } from "./_string-utils";

export function calcDateDurationInDays(fromDateMs: number, toDateMs: number) {
  return Math.ceil((toDateMs - fromDateMs) / (24 * 60 * 60 * 1000));
}

export function makeMyDate(dateString: string) {
  const date = new Date(dateString);

  return `${zeroPadding(date.getFullYear(), 4)}.${zeroPadding(date.getMonth() + 1, 2)}.${zeroPadding(date.getDate(), 2)}`
}